(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-product-purchase-card"] && !Shopify.designMode) return;
  try {
    /**
   * 通用产品购买卡片控制器。
   * 负责同步变体及订阅价格，并处理加入购物车、打开购物车抽屉和立即购买跳转。
   */
  class ProductPurchaseCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return

      this.price = this.querySelector('[data-product-purchase-card-price]')
      this.comparePrice = this.querySelector('[data-product-purchase-card-compare-price]')
      this.save = this.querySelector('[data-product-purchase-card-save]')
      this.variantImage = this.querySelector('[data-product-purchase-card-image]')
      this.form = this.querySelector('.product-purchase-card__form')
      this.ctaButtons = this.querySelectorAll('.product-purchase-card__button[type="submit"]')
      this.moneyFormat = this.dataset.moneyFormat || ''
      if (!this.price || !this.comparePrice || !this.form) return

      this.initialized = true
      this.listenerAbort = new AbortController()
      const { signal } = this.listenerAbort
      this.addEventListener('change', this.onChange, { signal })
      this.form.addEventListener('submit', this.onSubmit, { signal })
      this.ctaButtons.forEach(button => this.setCtaLoading(button, false))
      this.updateFromPurchaseOption()
    }

    disconnectedCallback() {
      this.listenerAbort?.abort()
      this.initialized = false
    }

    setCtaLoading(button, isLoading) {
      if (!button) return

      button.classList.toggle('loading', isLoading)
      button.disabled = isLoading || button.classList.contains('is-disabled')
      button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading)
    }

    activePurchaseRoot() {
      return this.querySelector('[data-purchase-variant-panel]:not([hidden])') || this
    }

    activateVariantPanel(variantId) {
      const panels = [...this.querySelectorAll('[data-purchase-variant-panel]')]
      if (!panels.length) return false

      const activePanel = panels.find(panel => panel.dataset.variantId === String(variantId)) || panels[0]
      panels.forEach(panel => {
        const isActive = panel === activePanel
        panel.hidden = !isActive
        panel.disabled = !isActive
      })

      const available = activePanel.dataset.variantAvailable !== 'false'
      this.querySelectorAll('.product-purchase-card__actions [type="submit"]').forEach(button => {
        button.disabled = !available
        button.classList.toggle('is-disabled', !available)
      })
      this.dataset.variantPrice = activePanel.dataset.variantPrice || this.dataset.variantPrice
      this.dataset.variantPriceFormatted = activePanel.dataset.variantPriceFormatted || ''
      this.dataset.variantComparePriceFormatted = activePanel.dataset.variantComparePriceFormatted || ''
      this.updateFromPurchaseOption()
      return true
    }

    buildCartPayload(formData) {
      const bundleIds = formData.get('bundle_ids')
      if (bundleIds) {
        const bundlePlanInput =
          this.activePurchaseRoot().querySelector(
            'input[name^="bundle-plan-"]:checked, input[name="bundle_selling_plan"]:checked'
          ) || this.querySelector('[data-component-subscription-select] input[name="bundle_selling_plan"]')
        const bundlesSellingPlan = bundlePlanInput?.value || ''
        const selectedPlanPrice = bundlePlanInput?.dataset.bundlePlanPrice || ''
        const bundlePrice = selectedPlanPrice || formData.get('bundle_price')
        const bundleTitle = formData.get('bundle_title') || ''
        const items = bundleIds
          .split(';')
          .filter(Boolean)
          .map(bundle => {
            const [variantId, bundleQuantity] = bundle.split(':')
            const item = {
              quantity: Number.parseInt(bundleQuantity, 10) || 1,
              id: variantId,
              properties: {
                'Part Of': bundleTitle.replace('||', ' '),
                __is_bundle: bundlesSellingPlan ? `${bundleIds};${bundlesSellingPlan}` : bundleIds,
                __bundle_img: formData.get('bundle_img') || '',
                __bundle_url: formData.get('bundle_url') || '',
                __bundle_title: bundleTitle,
                __bundle_price: bundlePrice
              }
            }
            if (bundlesSellingPlan) {
              item.selling_plan = bundlesSellingPlan
              item.properties[APPSTLE_PROPS.SELECTED_PLAN] = bundlesSellingPlan
              item.properties[APPSTLE_PROPS.FULFILLMENT_COUNT] = '1'
            }
            return item
          })

        return { items }
      }

      const variantId = Number(formData.get('id'))
      if (!variantId) return { items: [] }

      const item = { id: variantId, quantity: 1 }
      const sellingPlanInput = this.activePurchaseRoot().querySelector(
        'input[name^="selling-plan-"]:checked, input[name="selling_plan"]:checked'
      )
      const sellingPlan = sellingPlanInput ? sellingPlanInput.value : formData.get('selling_plan')
      if (sellingPlan) {
        item.selling_plan = Number(sellingPlan)
        item.properties = {
          [APPSTLE_PROPS.SELECTED_PLAN]: sellingPlan,
          [APPSTLE_PROPS.FULFILLMENT_COUNT]: '1'
        }
      }

      return { items: [item] }
    }

    sendCartEvent(eventName, variantId) {
      if (typeof window.WDSendEvent !== 'function') return

      window.WDSendEvent(eventName, {
        event_source: window.location.pathname,
        event_category: this.dataset.eventCategory,
        event_action: this.dataset.variantSku || `${variantId}`
      })
    }

    async submitBuyNow(payload, variantId) {
      try {
        const checkoutUrl = await CartActions.buyNowWithItems(payload.items)
        this.sendCartEvent('wd_buy_now', variantId)
        window.location.href = checkoutUrl
      } catch (error) {
        console.error(error)
      }
    }

    async submitAddToCart(payload, variantId) {
      const cart = CartActions.getCartComponent()
      if (typeof cart?.enableLoading === 'function') cart.enableLoading(0)

      try {
        cart?.attachAddPayload?.(payload)
        const response = await CartActions.addItemsToCart(payload, { variantId })
        if (!response) return

        this.sendCartEvent('wd_add_to_cart', variantId)
        if (typeof cart?.applyAddResponse !== 'function') {
          window.location = window.routes?.cart_url || '/cart'
          return
        }
        await cart.applyAddResponse(response, {
          source: 'product-purchase-card',
          productVariantId: variantId
        })
      } finally {
        if (typeof cart?.disableLoading === 'function') cart.disableLoading(0)
      }
    }

    onSubmit = async event => {
      event.preventDefault()
      if (this.isSubmitting) return

      const formData = new FormData(event.currentTarget, event.submitter)
      const intent = event.submitter?.value || 'add-to-cart'
      const payload = this.buildCartPayload(formData)
      const variantId = payload.items[0]?.id
      if (!variantId) return

      this.isSubmitting = true
      this.setCtaLoading(event.submitter, true)

      try {
        if (intent === 'buy-now') {
          await this.submitBuyNow(payload, variantId)
          return
        }

        await this.submitAddToCart(payload, variantId)
      } finally {
        this.isSubmitting = false
        this.setCtaLoading(event.submitter, false)
      }
    }

    onChange = event => {
      if (event.target.matches('[data-variant-picker-input]')) {
        const selectedVariant = this.querySelector('[data-variant-picker-option][aria-selected="true"]')
        if (!selectedVariant) return

        this.dataset.variantPrice = selectedVariant.dataset.variantPrice
        this.dataset.variantPriceFormatted = selectedVariant.dataset.variantPriceFormatted
        this.dataset.variantComparePriceFormatted = selectedVariant.dataset.variantComparePriceFormatted
        this.dataset.variantSku = selectedVariant.dataset.variantSku
        const variantTitle = this.querySelector('[data-product-purchase-card-variant-title]')
        const productLink = this.querySelector('[data-product-purchase-card-link]')
        if (variantTitle) variantTitle.textContent = selectedVariant.dataset.variantTitle
        if (productLink) productLink.href = selectedVariant.dataset.variantUrl
        this.updateVariantImage(selectedVariant.dataset.variantImageUrl)
        this.syncBundleFields(selectedVariant)
        if (this.activateVariantPanel(selectedVariant.dataset.variantId)) return
        if (this.querySelector('[data-component-subscription-select]')) {
          this.dataset.variantPrice = selectedVariant.dataset.variantPrice
          this.dataset.variantPriceFormatted = selectedVariant.dataset.variantPriceFormatted
          this.dataset.variantComparePriceFormatted = selectedVariant.dataset.variantComparePriceFormatted
          this.updateFromPurchaseOption()
          return
        }

        this.dataset.variantPrice = selectedVariant.dataset.variantPrice
        this.dataset.variantPriceFormatted = selectedVariant.dataset.variantPriceFormatted
        this.dataset.variantComparePriceFormatted = selectedVariant.dataset.variantComparePriceFormatted
        this.updatePrice(this.dataset.variantPriceFormatted, this.dataset.variantComparePriceFormatted)
        return
      }

      if (event.target.matches('input[name="selling_plan"], input[name="bundle_selling_plan"]')) {
        this.updateFromPurchaseOption()
      }
    }

    formatMoney(cents) {
      const amount = (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      if (this.moneyFormat) return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)

      const reference = this.dataset.variantPriceFormatted || this.price?.textContent.trim() || '$0.00'
      const symbol = reference.match(/^[^\d-]+/)?.[0] || '$'
      return `${symbol}${amount}`
    }

    updateFromPurchaseOption() {
      const purchaseRoot = this.activePurchaseRoot()
      const selectedBundleInput = purchaseRoot.querySelector(
        'input[name^="bundle-plan-"]:checked, input[name="bundle_selling_plan"]:checked'
      )
      if (selectedBundleInput) {
        const selectedOption = selectedBundleInput.closest('.product-subscription__option')
        const selectedPrice = selectedOption?.querySelector('[data-subscription-current]')?.textContent.trim()
        const subscriptionComparePrice = selectedOption
          ?.querySelector('[data-subscription-original]')
          ?.textContent.trim()
        const comparePrice = selectedBundleInput.value
          ? subscriptionComparePrice
          : this.dataset.variantComparePriceFormatted

        this.updatePrice(selectedPrice || this.dataset.variantPriceFormatted, comparePrice)
        return
      }

      const selectedInput = purchaseRoot.querySelector(
        'input[name^="selling-plan-"]:checked, input[name="selling_plan"]:checked'
      )
      if (selectedInput) {
        const selectedOption = selectedInput.closest('.product-subscription__option')
        const selectedPrice = selectedOption?.querySelector('[data-subscription-current]')?.textContent.trim()
        const subscriptionComparePrice = selectedOption
          ?.querySelector('[data-subscription-original]')
          ?.textContent.trim()
        const comparePrice = selectedInput.value ? subscriptionComparePrice : this.dataset.variantComparePriceFormatted

        this.updatePrice(selectedPrice || this.dataset.variantPriceFormatted, comparePrice)
        return
      }

      const selectRoot = this.querySelector('[data-component-subscription-select]')
      if (!selectRoot) {
        this.updatePrice(this.dataset.variantPriceFormatted, this.dataset.variantComparePriceFormatted)
        return
      }

      const selectedOption = selectRoot.querySelector('[data-subscription-select-option][aria-selected="true"]')
      const sellingPlanId = selectedOption?.dataset.sellingPlanId || ''
      if (!selectedOption || !sellingPlanId) {
        this.updatePrice(this.dataset.variantPriceFormatted, this.dataset.variantComparePriceFormatted)
        return
      }

      const variantId =
        this.querySelector('[data-variant-picker-input]')?.value || this.querySelector('input[name="id"]')?.value
      const planEntry =
        typeof selectRoot.getPlanEntry === 'function'
          ? selectRoot.getPlanEntry(sellingPlanId)
          : (() => {
              try {
                const planMap = JSON.parse(selectRoot.dataset.planMap || '{}')
                return planMap[sellingPlanId] || planMap[String(sellingPlanId)] || null
              } catch {
                return null
              }
            })()
      if (selectedOption.dataset.planPrice) {
        this.updatePrice(
          selectedOption.dataset.priceFormatted || this.formatMoney(Number(selectedOption.dataset.planPrice)),
          selectedOption.dataset.compareFormatted || '',
          selectedOption.dataset.saveText || ''
        )
        return
      }

      const planPrice = (planEntry?.prices || '').split(',').find(entry => entry.startsWith(`${variantId}:`))
      const finalPrice = planPrice
        ? Number(planPrice.slice(planPrice.indexOf(':') + 1))
        : Number(this.dataset.variantPrice)

      this.updatePrice(
        this.formatMoney(Math.max(0, Math.round(finalPrice))),
        this.dataset.variantPriceFormatted,
        selectedOption.dataset.saveText || ''
      )
    }

    syncBundleFields(option) {
      const fields = {
        bundle_ids: option?.dataset.bundleIds || '',
        bundle_img: option?.dataset.bundleImg || '',
        bundle_title: option?.dataset.bundleTitle || '',
        bundle_price: option?.dataset.bundlePrice || '',
        bundle_url: option?.dataset.bundleUrl || ''
      }

      Object.entries(fields).forEach(([name, value]) => {
        const input = this.querySelector(`input[name="${name}"]`)
        if (!input || input.closest('[data-purchase-variant-panel]')) return
        input.value = value
        input.disabled = value === ''
      })
    }

    updateSave(saveText) {
      if (!this.save) return

      this.save.textContent = saveText || ''
      this.save.hidden = !saveText
    }

    updatePrice(price, comparePrice, saveText = '') {
      if (!price) return

      this.price.textContent = price
      this.comparePrice.textContent = comparePrice || ''
      this.comparePrice.hidden = !comparePrice || comparePrice === price
      this.updateSave(saveText)
    }

    updateVariantImage(imageUrl) {
      if (!this.variantImage || !imageUrl) return

      this.variantImage.src = imageUrl
      this.variantImage.removeAttribute('srcset')
    }
  }

  if (!customElements.get('product-purchase-card')) {
    customElements.define('product-purchase-card', ProductPurchaseCard)
  }

  let productVariantPickerId = 0

  /**
   * 通用产品变体选择器。
   * 提供可访问的自定义下拉交互，并同步产品表单变体 ID、订阅方案和卡片价格。
   */
  class ProductVariantPicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return

      this.trigger = this.querySelector('[data-variant-picker-trigger]')
      this.listbox = this.querySelector('[data-variant-picker-options]')
      this.input = this.querySelector('[data-variant-picker-input]')
      this.label = this.querySelector('[data-variant-picker-label]')
      if (!this.trigger || !this.listbox || !this.input || !this.label) return

      this.initialized = true
      productVariantPickerId += 1
      this.listbox.id = `ProductVariantOptions-${productVariantPickerId}`
      this.trigger.setAttribute('aria-controls', this.listbox.id)

      this.addEventListener('click', this.onClick)
      this.addEventListener('keydown', this.onKeydown)
      this.addEventListener('focusout', this.onFocusout)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick)
      this.removeEventListener('keydown', this.onKeydown)
      this.removeEventListener('focusout', this.onFocusout)
      this.initialized = false
    }

    get enabledOptions() {
      return [...this.querySelectorAll('[data-variant-picker-option][aria-disabled="false"]')]
    }

    onClick = event => {
      if (event.target.closest('[data-variant-picker-trigger]')) {
        this.toggle()
        return
      }

      const option = event.target.closest('[data-variant-picker-option]')
      if (option && this.contains(option)) this.selectOption(option)
    }

    onKeydown = event => {
      const option = event.target.closest('[data-variant-picker-option]')

      if (!option) {
        if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return

        event.preventDefault()
        if (event.key === 'Escape') {
          this.close()
          return
        }

        this.open()
        const selectedOption = this.querySelector('[data-variant-picker-option][aria-selected="true"]')
        const fallbackOption = event.key === 'ArrowUp' ? this.enabledOptions.at(-1) : this.enabledOptions[0]
        ;(selectedOption?.getAttribute('aria-disabled') === 'false' ? selectedOption : fallbackOption)?.focus()
        return
      }

      const options = this.enabledOptions
      const currentIndex = options.indexOf(option)
      let targetIndex = currentIndex

      if (event.key === 'ArrowDown') targetIndex = (currentIndex + 1) % options.length
      if (event.key === 'ArrowUp') targetIndex = (currentIndex - 1 + options.length) % options.length
      if (event.key === 'Home') targetIndex = 0
      if (event.key === 'End') targetIndex = options.length - 1

      if (targetIndex !== currentIndex) {
        event.preventDefault()
        options[targetIndex]?.focus()
        return
      }

      if (['Enter', ' '].includes(event.key)) {
        event.preventDefault()
        this.selectOption(option)
        return
      }

      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        this.trigger.focus()
      }
    }

    onFocusout = event => {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.close()
    }

    toggle() {
      if (this.listbox.hidden) {
        this.open()
        return
      }

      this.close()
    }

    open() {
      document.querySelectorAll('product-variant-picker').forEach(picker => {
        if (picker !== this && typeof picker.close === 'function') picker.close()
      })
      this.listbox.hidden = false
      this.trigger.setAttribute('aria-expanded', 'true')
    }

    close() {
      this.listbox.hidden = true
      this.trigger.setAttribute('aria-expanded', 'false')
    }

    selectOption(option) {
      if (option.getAttribute('aria-disabled') === 'true') return

      this.querySelectorAll('[data-variant-picker-option]').forEach(item => {
        item.setAttribute('aria-selected', item === option ? 'true' : 'false')
      })

      this.input.value = option.dataset.variantId
      this.label.textContent = option.textContent.trim()
      this.input.dispatchEvent(new Event('change', { bubbles: true }))

      const card = this.closest('product-purchase-card')
      if (!card?.querySelector('[data-purchase-variant-panel]')) {
        const variantChangeDetail = {
          price: Number(option.dataset.variantPrice),
          variantId: option.dataset.variantId
        }
        card?.querySelector('[data-component-subscription-radio]')?.dispatchEvent(
          new CustomEvent('component-subscription-radio:variant-change', {
            detail: variantChangeDetail
          })
        )
        card?.querySelector('[data-component-subscription-select]')?.dispatchEvent(
          new CustomEvent('component-subscription-select:variant-change', {
            detail: variantChangeDetail
          })
        )
      }

      this.close()
      this.trigger.focus()
    }
  }

  if (!customElements.get('product-variant-picker')) {
    customElements.define('product-variant-picker', ProductVariantPicker)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-scroll-tabs"] && !Shopify.designMode) return;
  try {
    class ScrollTabs extends HTMLElement {
    connectedCallback() {
      this.bindTabs(true)
    }

    bindTabs(retry = false) {
      this.listenerAbort?.abort()
      this.listenerAbort = new AbortController()
      const { signal } = this.listenerAbort

      this.tabs = [...this.querySelectorAll('[role="tab"]')]
      if (!this.tabs.length) {
        if (retry) queueMicrotask(() => this.isConnected && this.bindTabs())
        return
      }

      this.addEventListener('click', this.onClick, { signal })
      this.addEventListener('keydown', this.onKeydown, { signal })
      this.bindDrag(signal)

      const selectedTab = this.tabs.find(tab => tab.classList.contains('selected'))
      if (selectedTab) window.requestAnimationFrame(() => this.scrollTabToStart(selectedTab))
    }

    disconnectedCallback() {
      this.listenerAbort?.abort()
      if (this.dragIgnoreTimer) window.clearTimeout(this.dragIgnoreTimer)
    }

    onClick = event => {
      if (this.dragIgnoreClick) {
        this.dragIgnoreClick = false
        event.preventDefault()
        event.stopPropagation()
        return
      }

      const tab = event.target.closest('[role="tab"]')
      if (!tab || !this.contains(tab)) return

      event.stopPropagation()
      this.selectTab(tab)
    }

    onKeydown = event => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return

      const tab = event.target.closest('[role="tab"]')
      if (!tab || !this.contains(tab)) return

      const currentIndex = this.tabs.indexOf(tab)
      if (currentIndex < 0) return

      let targetIndex = currentIndex
      if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % this.tabs.length
      if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length
      if (event.key === 'Home') targetIndex = 0
      if (event.key === 'End') targetIndex = this.tabs.length - 1
      if (targetIndex === currentIndex) return

      event.preventDefault()
      this.selectTab(this.tabs[targetIndex], { focus: true })
    }

    selectTab(tab, { focus = false, silent = false } = {}) {
      if (!tab || !this.contains(tab)) return

      this.tabs.forEach(item => {
        const selected = item === tab
        item.classList.toggle('selected', selected)
        item.setAttribute('aria-selected', selected ? 'true' : 'false')
        item.tabIndex = selected ? 0 : -1
      })

      this.scrollTabToStart(tab)
      if (focus) tab.focus()
      if (silent) return

      this.dispatchEvent(
        new CustomEvent('scroll-tabs:select', {
          bubbles: true,
          detail: { tab }
        })
      )
    }

    scrollTabToStart(tab) {
      if (!tab || this.scrollWidth <= this.clientWidth) return

      const tabLeft = tab.getBoundingClientRect().left - this.getBoundingClientRect().left
      this.scrollTo({
        left: this.scrollLeft + tabLeft,
        behavior: 'smooth'
      })
    }

    bindDrag(signal) {
      const state = {
        pointerId: null,
        startX: 0,
        startY: 0,
        startScrollLeft: 0,
        moved: false,
        axis: null
      }

      const getPoint = event => {
        const touch = event.touches?.[0]
        if (touch) return { x: touch.clientX, y: touch.clientY }
        return { x: event.clientX, y: event.clientY }
      }

      const isActiveTouch = event => event.touches && state.pointerId === 'touch'

      const isActivePointer = event => !event.touches && state.pointerId === event.pointerId

      const onMove = event => {
        if (!isActiveTouch(event) && !isActivePointer(event)) return

        const point = getPoint(event)
        const deltaX = point.x - state.startX
        const deltaY = point.y - state.startY

        if (!state.axis) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return
          state.axis = Math.abs(deltaX) >= Math.abs(deltaY) ? 'x' : 'y'
          if (state.axis === 'y') return
          state.moved = true
          this.classList.add('is-dragging')
          if (event.pointerId != null) this.setPointerCapture(event.pointerId)
        }

        if (state.axis !== 'x') return
        event.preventDefault()
        this.scrollLeft = state.startScrollLeft - deltaX
      }

      const onUp = event => {
        const isTouch = event.type.startsWith('touch')
        if (isTouch && state.pointerId !== 'touch') return
        if (!isTouch && state.pointerId !== event.pointerId) return

        if (!isTouch) {
          this.removeEventListener('pointermove', onMove)
          this.removeEventListener('pointerup', onUp)
          this.removeEventListener('pointercancel', onUp)
        }

        this.classList.remove('is-dragging')

        if (state.moved) {
          this.dragIgnoreClick = true
          if (this.dragIgnoreTimer) window.clearTimeout(this.dragIgnoreTimer)
          this.dragIgnoreTimer = window.setTimeout(
            () => {
              this.dragIgnoreClick = false
            },
            isTouch ? 300 : 0
          )
        }

        state.pointerId = null
        state.moved = false
        state.axis = null
      }

      this.addEventListener(
        'pointerdown',
        event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return
          if (this.scrollWidth <= this.clientWidth) return

          state.pointerId = event.pointerId
          state.startX = event.clientX
          state.startY = event.clientY
          state.startScrollLeft = this.scrollLeft
          state.moved = false
          state.axis = null
          this.addEventListener('pointermove', onMove, { signal, passive: false })
          this.addEventListener('pointerup', onUp, { signal })
          this.addEventListener('pointercancel', onUp, { signal })
        },
        { signal }
      )

      this.addEventListener(
        'touchstart',
        event => {
          if (event.touches.length !== 1) return
          if (this.scrollWidth <= this.clientWidth) return

          const touch = event.touches[0]
          state.pointerId = 'touch'
          state.startX = touch.clientX
          state.startY = touch.clientY
          state.startScrollLeft = this.scrollLeft
          state.moved = false
          state.axis = null
        },
        { signal, passive: true }
      )
      this.addEventListener('touchmove', onMove, { signal, passive: false })
      this.addEventListener('touchend', onUp, { signal })
      this.addEventListener('touchcancel', onUp, { signal })
    }
  }

  if (!customElements.get('scroll-tabs')) {
    customElements.define('scroll-tabs', ScrollTabs)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-subscription-bundles-radio"] && !Shopify.designMode) return;
  try {
    const initBundlePlanPriceSync = () => {
    document.querySelectorAll('[data-component-subscription-radio]').forEach(container => {
      if (container.dataset.bundlePlanPriceSync === 'true') return
      if (!container.querySelector('input[name="bundle_selling_plan"], input[name^="bundle-plan-"]')) return

      const productInfo = container.closest('product-info')
      if (!productInfo || container.closest('product-purchase-card')) return

      container.dataset.bundlePlanPriceSync = 'true'

      const syncPrices = () => {
        const checked = container.querySelector(
          'input[name="bundle_selling_plan"]:checked, input[name^="bundle-plan-"]:checked'
        )
        const option = checked?.closest('label')
        const priceText = option?.querySelector('[data-subscription-current]')?.textContent.trim()
        if (!priceText) return

        const compareText = option.querySelector('[data-subscription-original]')?.textContent.trim() || ''
        const saveText = option.querySelector('[data-subscription-save]')?.textContent.replace(/\s+/g, ' ').trim() || ''
        const mainPrice = productInfo.querySelector('.product-info-price-content .product-price-value')
        const mainCompare = productInfo.querySelector('.product-info-price-content .product-price-del')
        const mainOff = productInfo.querySelector('.product-info-price-content .product-info-price-discount-off')
        const bottomPrice = productInfo.querySelector(
          '.product-info-bottom-price-container .product-info-bottom-price-value'
        )
        const bottomCompare = productInfo.querySelector('.product-info-bottom-price-container .product-price-del')
        const bottomOff = productInfo.querySelector(
          '.product-info-bottom-price-container .product-info-bottom-price-discount-off'
        )
        const bottomDiscount = productInfo.querySelector(
          '.product-info-bottom-price-container .product-info-bottom-price-discount-container'
        )

        if (mainPrice) mainPrice.textContent = priceText
        if (bottomPrice) bottomPrice.textContent = priceText
        ;[
          [mainCompare, compareText],
          [bottomCompare, compareText],
          [mainOff, saveText],
          [bottomOff, saveText]
        ].forEach(([node, text]) => {
          if (!node) return
          node.textContent = text
          node.hidden = !text
        })
        if (bottomDiscount) bottomDiscount.hidden = !compareText && !saveText

        const planCents = checked.value ? Number(checked.dataset.bundlePlanPrice) : NaN
        const bundleCents = Number(productInfo.querySelector('input[name="bundle_price"]')?.value)
        const cents = Number.isFinite(planCents) ? planCents : bundleCents
        const pointsRoot = productInfo.querySelector('[data-member-points]')
        if (!pointsRoot || !Number.isFinite(cents)) return

        const pointRate = Number(pointsRoot.dataset.pointRate) || 10
        const point = Math.floor((cents / 100) * pointRate)
        const worthCents = Math.floor((point * 3) / 10)
        const pointNode = pointsRoot.querySelector('[data-member-point]')
        const worthNode = pointsRoot.querySelector('[data-member-worth]')
        if (pointNode) pointNode.textContent = String(point).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        if (worthNode && pointsRoot.dataset.moneyFormat) {
          const amount = (worthCents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          worthNode.textContent = pointsRoot.dataset.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
        }
      }

      container.addEventListener('change', event => {
        if (!event.target.matches('input[name="bundle_selling_plan"], input[name^="bundle-plan-"]')) return
        syncPrices()
      })

      syncPrices()

      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return

      const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        if (container.isConnected) {
          requestAnimationFrame(syncPrices)
          return
        }

        unsubscribeVariantChange()
        requestAnimationFrame(initBundlePlanPriceSync)
      })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlePlanPriceSync)
  } else {
    initBundlePlanPriceSync()
  }

  document.addEventListener('product-info:loaded', initBundlePlanPriceSync)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-subscription-radio"] && !Shopify.designMode) return;
  try {
    /**
   * 订购省单选组件。用 Custom Element 承接变体切换，避免 template 克隆后丢失监听。
   */
  class SubscriptionPlanRadio extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return
      this.initialized = true

      this.addEventListener('component-subscription-radio:variant-change', this.onVariantChange)

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onProductInfoVariantChange)
      }
    }

    disconnectedCallback() {
      this.removeEventListener('component-subscription-radio:variant-change', this.onVariantChange)
      this.unsubscribeVariantChange?.()
      this.unsubscribeVariantChange = null
      this.initialized = false
    }

    selectOneTimePurchase() {
      const oneTimeInput = this.querySelector('input[name="selling_plan"][value=""]')
      if (!oneTimeInput) return

      oneTimeInput.checked = true
      oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    selectDefaultPurchaseOption() {
      const oneTimeInput = this.querySelector('input[name="selling_plan"][value=""]')
      const subscriptionInput = this.querySelector(
        '[data-subscription-option][data-subscription-visible="true"] input[name="selling_plan"]'
      )
      const defaultInput = this.dataset.defaultChecked === 'true' ? subscriptionInput || oneTimeInput : oneTimeInput

      if (!defaultInput) return

      defaultInput.checked = true
      defaultInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    formatMoney(cents) {
      const reference = this.querySelector('[data-subscription-current]')?.textContent.trim() || '$0.00'
      const symbol = reference.match(/^[^\d-]+/)?.[0] || '$'
      return `${symbol}${(Number(cents) / 100).toFixed(2)}`
    }

    updateState({ price, variantId } = {}) {
      const nextPrice = Number(price)
      if (!Number.isFinite(nextPrice)) return

      this.querySelectorAll('[data-subscription-option]').forEach(option => {
        if (variantId) {
          const isVisible = option.dataset.variantIds.includes(`,${variantId},`)
          option.hidden = !isVisible
          option.style.display = isVisible ? '' : 'none'
          option.dataset.subscriptionVisible = String(isVisible)
        }

        const current = option.querySelector('[data-subscription-current]')
        const original = option.querySelector('[data-subscription-original]')
        const adjustmentType = option.dataset.adjustmentType
        const adjustmentValue = Number(option.dataset.adjustmentValue)
        let finalPrice = nextPrice

        if (adjustmentType === 'percentage') {
          finalPrice = nextPrice - nextPrice * (adjustmentValue / 100)
        } else if (adjustmentType === 'fixed_amount') {
          finalPrice = nextPrice - adjustmentValue
        }

        if (current) current.textContent = this.formatMoney(Math.max(0, finalPrice))
        if (original) original.textContent = this.formatMoney(nextPrice)
      })

      const oneTimeCurrent = this.querySelector('.product-subscription__item--single [data-subscription-current]')
      if (oneTimeCurrent) oneTimeCurrent.textContent = this.formatMoney(nextPrice)

      const checkedInput = this.querySelector('input[name="selling_plan"]:checked')
      const checkedOption = checkedInput?.closest('[data-subscription-option]')

      if (variantId) {
        this.selectDefaultPurchaseOption()
        return
      }

      if (!checkedInput || checkedOption?.hidden) {
        const nextInput =
          this.dataset.defaultChecked === 'true'
            ? this.querySelector(
                '[data-subscription-option][data-subscription-visible="true"] input[name="selling_plan"]'
              )
            : this.querySelector('input[name="selling_plan"][value=""]')

        if (nextInput) {
          nextInput.checked = true
          nextInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    }

    onVariantChange = event => {
      this.updateState({
        price: Number(event.detail?.price),
        variantId: event.detail?.variantId
      })
    }

    onProductInfoVariantChange = ({ data }) => {
      const sourceSelector = `[data-component-subscription-radio][data-product-id="${this.dataset.productId}"][data-product-form-id="${this.dataset.productFormId}"]`
      const source = data?.html?.querySelector(sourceSelector)
      if (!source) return

      this.innerHTML = source.innerHTML
      this.selectOneTimePurchase()
    }
  }

  if (!customElements.get('subscription-plan-radio')) {
    customElements.define('subscription-plan-radio', SubscriptionPlanRadio)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-subscription-select"] && !Shopify.designMode) return;
  try {
    class SubscriptionPlanSelect extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return

      this.trigger = this.querySelector('[data-subscription-select-trigger]')
      this.listbox = this.querySelector('[data-subscription-select-options]')
      this.input = this.querySelector('[data-subscription-select-input]')
      this.label = this.querySelector('[data-subscription-select-label]')
      if (!this.trigger || !this.listbox || !this.input || !this.label) return

      this.initialized = true
      this.listbox.id = `SubscriptionSelectOptions-${this.dataset.productId}-${this.dataset.productFormId || 'form'}`
      this.trigger.setAttribute('aria-controls', this.listbox.id)

      this.addEventListener('click', this.onClick)
      this.addEventListener('keydown', this.onKeydown)
      this.addEventListener('focusout', this.onFocusout)
      this.addEventListener('component-subscription-select:variant-change', this.onVariantChange)

      const defaultOption = this.getDefaultOption()
      if (defaultOption) this.selectOption(defaultOption, { keepOpen: true })
      this.syncOptionsVisibility()
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick)
      this.removeEventListener('keydown', this.onKeydown)
      this.removeEventListener('focusout', this.onFocusout)
      this.removeEventListener('component-subscription-select:variant-change', this.onVariantChange)
      this.planMap = null
      this.initialized = false
    }

    getPlanMap() {
      if (this.planMap != null) return this.planMap

      try {
        this.planMap = JSON.parse(this.dataset.planMap || '{}')
      } catch {
        this.planMap = {}
      }

      return this.planMap
    }

    getPlanEntry(planId) {
      if (!planId) return null

      const planMap = this.getPlanMap()
      return planMap[planId] || planMap[String(planId)] || null
    }

    getBundlePlan(variantId) {
      if (!variantId) return null

      const row = (this.dataset.bundlePlans || '').split('||').find(entry => entry.startsWith(`${variantId}@@`))
      if (!row) return null

      const [, planId, price, save, priceFormatted, compareFormatted, label] = row.split('@@')
      return { planId, price, save, priceFormatted, compareFormatted, label }
    }

    syncBundleOption(variantId) {
      const option = this.querySelector('[data-bundle-subscription-option]')
      if (!option) return null

      const plan = this.getBundlePlan(variantId)
      option.hidden = !plan
      option.dataset.subscriptionVisible = String(Boolean(plan))
      if (!plan) return null

      option.dataset.sellingPlanId = plan.planId
      option.dataset.planPrice = plan.price
      option.dataset.saveText = plan.save || ''
      option.dataset.priceFormatted = plan.priceFormatted || ''
      option.dataset.compareFormatted = plan.compareFormatted || ''
      option.textContent = plan.label
      return plan
    }

    syncOptionsVisibility() {
      const hasSubscription = Boolean(this.querySelector('[data-subscription-option]:not([hidden])'))
      this.hidden = !hasSubscription
      if (!hasSubscription) this.close()
    }

    get enabledOptions() {
      return [...this.querySelectorAll('[data-subscription-select-option]:not([hidden])')]
    }

    getDefaultOption() {
      const subscriptionOption = this.querySelector('[data-subscription-option][data-subscription-visible="true"]')
      const oneTimeOption = this.querySelector('[data-subscription-option-onetime]')
      if (this.dataset.defaultChecked === 'true') return subscriptionOption || oneTimeOption
      return oneTimeOption
    }

    onClick = event => {
      if (event.target.closest('[data-subscription-select-trigger]')) {
        this.toggle()
        return
      }

      const option = event.target.closest('[data-subscription-select-option]')
      if (option && this.contains(option)) this.selectOption(option)
    }

    onKeydown = event => {
      const option = event.target.closest('[data-subscription-select-option]')

      if (!option) {
        if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return

        event.preventDefault()
        if (event.key === 'Escape') {
          this.close()
          return
        }

        this.open()
        const selectedOption = this.querySelector('[data-subscription-select-option][aria-selected="true"]')
        const fallbackOption = event.key === 'ArrowUp' ? this.enabledOptions.at(-1) : this.enabledOptions[0]
        ;(selectedOption && !selectedOption.hidden ? selectedOption : fallbackOption)?.focus()
        return
      }

      const options = this.enabledOptions
      const currentIndex = options.indexOf(option)
      let targetIndex = currentIndex

      if (event.key === 'ArrowDown') targetIndex = (currentIndex + 1) % options.length
      if (event.key === 'ArrowUp') targetIndex = (currentIndex - 1 + options.length) % options.length
      if (event.key === 'Home') targetIndex = 0
      if (event.key === 'End') targetIndex = options.length - 1

      if (targetIndex !== currentIndex) {
        event.preventDefault()
        options[targetIndex]?.focus()
        return
      }

      if (['Enter', ' '].includes(event.key)) {
        event.preventDefault()
        this.selectOption(option)
        return
      }

      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        this.trigger.focus()
      }
    }

    onFocusout = event => {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.close()
    }

    onVariantChange = event => {
      const variantId = event.detail?.variantId
      if (!variantId) return

      const bundlePlan = this.syncBundleOption(variantId)
      const wrappedVariantId = `,${variantId},`
      this.querySelectorAll('[data-subscription-option]:not([data-bundle-subscription-option])').forEach(option => {
        const isVisible =
          !bundlePlan && Boolean(this.getPlanEntry(option.dataset.sellingPlanId)?.ids?.includes(wrappedVariantId))
        option.hidden = !isVisible
        option.dataset.subscriptionVisible = String(isVisible)
      })

      const selectedOption = this.querySelector('[data-subscription-select-option][aria-selected="true"]')
      if (selectedOption && !selectedOption.hidden) {
        this.selectOption(selectedOption, { keepOpen: true })
      } else {
        const defaultOption = this.getDefaultOption()
        if (defaultOption) this.selectOption(defaultOption, { keepOpen: true })
      }

      this.syncOptionsVisibility()
    }

    toggle() {
      if (this.listbox.hidden) {
        this.open()
        return
      }

      this.close()
    }

    open() {
      document.querySelectorAll('subscription-plan-select').forEach(select => {
        if (select !== this) select.close?.()
      })
      this.listbox.hidden = false
      this.trigger.setAttribute('aria-expanded', 'true')
    }

    close() {
      this.listbox.hidden = true
      this.trigger.setAttribute('aria-expanded', 'false')
    }

    selectOption(option, { keepOpen = false } = {}) {
      if (!option || option.hidden) return

      this.querySelectorAll('[data-subscription-select-option]').forEach(item => {
        item.setAttribute('aria-selected', item === option ? 'true' : 'false')
      })

      const purchaseCard = this.closest('product-purchase-card')
      const bundleVariantId =
        purchaseCard?.querySelector('[data-variant-picker-input]')?.value ||
        purchaseCard?.querySelector('input[name="id"]')?.value
      const useBundleInput =
        Boolean(option.dataset.planPrice) ||
        (this.dataset.bundleSelect === 'true' && this.getBundlePlan(bundleVariantId))
      this.input.name = useBundleInput ? 'bundle_selling_plan' : 'selling_plan'
      this.input.value = option.dataset.sellingPlanId || ''
      if (option.dataset.planPrice) this.input.dataset.bundlePlanPrice = option.dataset.planPrice
      else delete this.input.dataset.bundlePlanPrice
      this.label.textContent = option.textContent.trim()
      this.input.dispatchEvent(new Event('change', { bubbles: true }))

      if (keepOpen) return

      this.close()
      this.trigger.focus()
    }
  }

  if (!customElements.get('subscription-plan-select')) {
    customElements.define('subscription-plan-select', SubscriptionPlanSelect)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["points-activities-modal"] && !Shopify.designMode) return;
  try {
    /**
   * 属性：
   *   customer-id  — Smile 客户 ID，用于默认 fetch
   */
  class PointsActivitiesModal extends HTMLElement {
    constructor() {
      super()
      this.pointsTx = { list: [], nextCursor: null, loading: false }
    }

    get customerId() {
      return this.getAttribute('customer-id')
    }

    set customerId(val) {
      if (val != null) this.setAttribute('customer-id', String(val))
      else this.removeAttribute('customer-id')
    }

    connectedCallback() {
      this._modalContainer = this.closest('modal-container')
      this._onShow = () => {
        this.pointsTx = { list: [], nextCursor: null, loading: false }
        this._resetSkeleton()
        this._loadTransactions()
      }
      this._modalContainer?.addEventListener('modal:show', this._onShow)
    }

    disconnectedCallback() {
      this._modalContainer?.removeEventListener('modal:show', this._onShow)
    }

    /* ── 数据加载 ── */

    _resetSkeleton() {
      const table = this.querySelector('[data-points-activities-table]')
      if (!table) return
      table.querySelectorAll('.pa-row:not(.pa-row--header)').forEach(r => r.remove())
      this.querySelector('.pa-pagination-load-more')?.remove()
      const tpl = this.querySelector('[data-pa-skeleton-template]')
      if (!tpl) return
      const frag = document.createDocumentFragment()
      for (let i = 0; i < 5; i++) frag.appendChild(tpl.content.cloneNode(true))
      table.appendChild(frag)
    }

    async _fetch(cursor) {
      const query = {}
      if (this.customerId) query.customer_id = this.customerId
      if (cursor) query.cursor = cursor
      /* global waterdropAppApi */
      return waterdropAppApi({ proxy: 'rewards/smile', endpoint: '/points_transactions', query })
    }

    async _loadTransactions(cursor = '') {
      const isLoadMore = !!cursor
      this.pointsTx.loading = true
      try {
        const txRes = await this._fetch(cursor || null)
        const newTx = txRes?.points_transactions || []
        this.pointsTx.list = isLoadMore ? this.pointsTx.list.concat(newTx) : newTx
        this.pointsTx.nextCursor = txRes?.metadata?.next_cursor || null
      } catch (e) {
        console.error('[points-activities-modal] load', e)
        if (!isLoadMore) this.pointsTx.list = []
        window.showMessage?.('Failed to load data. Please refresh and try again.', 'error')
      } finally {
        this.pointsTx.loading = false
      }
      this._buildTable()
    }

    _buildTable() {
      const table = this.querySelector('[data-points-activities-table]')
      if (!table) return

      table.querySelectorAll('.pa-row:not(.pa-row--header)').forEach(r => r.remove())
      this.querySelector('.pa-pagination-load-more')?.remove()

      if (!this.pointsTx.list.length) {
        const emptyTpl = this.querySelector('[data-pa-empty-template]')
        if (emptyTpl) table.appendChild(emptyTpl.content.cloneNode(true))
        return
      }

      const rowTpl = this.querySelector('[data-pa-row-template]')
      const frag = document.createDocumentFragment()
      this.pointsTx.list
        .filter(tx => tx.description)
        .forEach(tx => {
          const row = rowTpl.content.cloneNode(true)
          row.querySelector('.pa-cell--time').textContent =
            `${PointsActivitiesModal.formatDateShort(tx.created_at)} ${PointsActivitiesModal.formatTime(tx.created_at)}`
          const sign = tx.points_change >= 0 ? '+' : ''
          row.querySelector('.pa-cell--points').textContent = `${sign}${tx.points_change} Points`
          row.querySelector('.pa-cell--action').textContent = tx.description
          frag.appendChild(row)
        })
      table.appendChild(frag)

      /* global createLoadMoreButton */
      if (this.pointsTx.nextCursor) {
        createLoadMoreButton({
          containerEl: this.querySelector('.pa-content') || this,
          wrapClass: 'pa-pagination-load-more',
          onClick: () => this._handleLoadMore()
        })
      }
    }

    async _handleLoadMore() {
      if (this.pointsTx.loading || !this.pointsTx.nextCursor) return
      await this._loadTransactions(this.pointsTx.nextCursor)
    }

    static formatDateShort(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
    }

    static formatTime(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  }

  if (!customElements.get('points-activities-modal')) {
    customElements.define('points-activities-modal', PointsActivitiesModal)
  }
  } catch(e) { console.error(e); }
})();

})();
